import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Sun = createReactComponent("Sun", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "5",
  key: "14nid7"
}], ["line", {
  x1: "12",
  y1: "1",
  x2: "12",
  y2: "3",
  key: "1ag9n0"
}], ["line", {
  x1: "12",
  y1: "21",
  x2: "12",
  y2: "23",
  key: "t04rde"
}], ["line", {
  x1: "4.22",
  y1: "4.22",
  x2: "5.64",
  y2: "5.64",
  key: "tbec0"
}], ["line", {
  x1: "18.36",
  y1: "18.36",
  x2: "19.78",
  y2: "19.78",
  key: "lbkhcg"
}], ["line", {
  x1: "1",
  y1: "12",
  x2: "3",
  y2: "12",
  key: "mbswk2"
}], ["line", {
  x1: "21",
  y1: "12",
  x2: "23",
  y2: "12",
  key: "an60ya"
}], ["line", {
  x1: "4.22",
  y1: "19.78",
  x2: "5.64",
  y2: "18.36",
  key: "1c679v"
}], ["line", {
  x1: "18.36",
  y1: "5.64",
  x2: "19.78",
  y2: "4.22",
  key: "co19ko"
}]]]);
export default Sun;